"use client"

import React, { useCallback, useEffect, useState } from 'react'
import "./style.css"
import {
    accountPackageActions, ActivityPreview, accountActions,
    calendarActions, formatMsg, Helper, SpinWrapper,
    PackageView, FilterDateSelector, activityActions,
    multicenterActions, CustomDropdown, timeutil, LinkWrapper,
    MobileFilterButton,
    FiltersBottomSheet,
    colors,
    useIsMobile,
    permissions
} from 'sharedresources';
import { useDispatch } from 'react-redux';
import { Button, Carousel, Col, Input, List, Row, Select } from 'antd';
import { useRouter } from 'next/navigation';
import { getItem, setItem } from '../../libs/encryptedStorage';
import { ArrowRightOutlined, SearchOutlined } from '@ant-design/icons';
import { PageHeaderWrapper } from '../wrapperComponents/page';


const { getEntityUpcomingSchedule } = calendarActions;
const { getAllAdminActivities, getAllListingActivities, getActivityType, getGuestActivities, getPackageAndCentersOfAccounts } = activityActions
const { getAllCentersList } = multicenterActions;
const { getPackageList } = accountPackageActions;
const { getAccountDetails } = accountActions;

const visibilityList = [
    { key: "PACKAGE", label: "Package" },
    { key: "CENTER", label: "Center" },
    { key: "PUBLIC", label: "Public" },
    { key: "USER", label: "User" }
];
const page = () => {

    const slices = Helper.getSelectorState(['login', 'accountPackageReducer', 'calendarReducer', 'activityReducer', 'multicenterReducer', 'accountReducer', 'userReducer']);
    const { firebase, accountPackageReducer, calendarReducer, multicenterReducer, activityReducer, accountReducer, userReducer } = slices;
    const isMobile = useIsMobile()
    const [packageList, setPackageList] = useState([]);
    const [activities, setActivities] = useState([]);
    const [dateRange, setDateRange] = useState<any>(null);
    const [centersMap, setCentersMap] = useState(new Map());
    const [packagesMap, setPackagesMap] = useState(new Map());
    const [peopleIdToObjMap, setPeopleIdToObjMap] = useState(new Map());
    const [search, setSearch] = useState(undefined);
    const [packageFilter, setPackageFilter] = useState(undefined);
    const [peopleFilter, setPeopleFilter] = useState([]);
    const [centerFilter, setCenterFilter] = useState(undefined);
    const [typeFilter, setTypeFilter] = useState(undefined);
    const [visibilityFilter, setVisibilityFilter] = useState(undefined);
    const [typeList, setTypeList] = useState([...Helper.postTypesMap.keys()])
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [showFiltersBottomSheet, setShowFiltersBottomSheet] = useState(false);
    const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);
    const [accountsFetched, setAccountFetched] = useState(false)
    const [filteredCentersList, setFilteredCentersList] = useState<any[]>([]);
    const { allCentersList } = multicenterReducer;
    const dispatch = useDispatch();
    const router = useRouter();

    const accountList = Helper.getAccountList(firebase).map(account => ({
        ...account,
        type: "Account"
    }));
    const userList = Helper.getUserList(firebase).map(user => ({
        ...user,
        type: "User"
    }));

    const teacherList = Helper.getTeacherList(firebase).map(teacher => ({
        ...teacher,
        type: "Staff"
    }));

    const isAccount = Helper.isAccount(firebase);
    useEffect(() => {
        getFilterUrlParam();
        dispatch(getPackageList({ loggedInData: firebase }));
        isAccount && dispatch(getEntityUpcomingSchedule({ firebase, entityId: firebase.user?.id }));
        isAccount && dispatch(getAccountDetails({ firebase, id: firebase.user?.id }));
        Helper.isUserLoggedIn(firebase) && dispatch(getPackageAndCentersOfAccounts({ firebase, accountId: firebase.user?.id }));
        !isAccount && dispatch(getAllCentersList({ firebase }));
        let pageNo: any = Helper.getUrlParam("pageNo");
        pageNo = Helper.checkUrlParam(pageNo, 1, "number");
        if (pageNo) setPageNo(pageNo);

        let pageSize: any = Helper.getUrlParam("pageSize");
        pageSize = Helper.checkUrlParam(pageSize, 10, "number");
        if (pageSize) setPageSize(pageSize);

        return () => {
            activityReducer.adminActivityChannel?.close();
            activityReducer.activityTypeChannel?.close();
            activityReducer.userActivityChans?.forEach(c => c?.close());
            Object.values(activityReducer.activityChannels).forEach((c: any) => c?.close());
            activityReducer.publicTimelineChan?.close();
            dispatch(activityActions.resetActivityOperationType(null));
        }
    }, []);

    useEffect(() => {
        if (Helper.isAccount(firebase)) {
            Object.values(activityReducer.activityChannels).forEach((c: any) => c?.close());
            activityReducer.activityListIds?.forEach(act => dispatch(activityActions.watchSingleActivity({ activityId: act, firebase })))
        }
    }, [activityReducer.activityListIds])

    useEffect(() => {
        if (accountReducer.operationType === "ACCOUNTS_FETCHED") {
            setAccountFetched(true)
            dispatch(accountActions.resetOperationType(null))
        }
    }, [accountReducer.operationType])

    useEffect(() => {
        if (firebase && dateRange?.length) {
            fetchActivity();
        }
    }, [dateRange, accountReducer.accountDetails?.users, accountsFetched]);

    useEffect(() => {
        if (firebase && dateRange?.length) {
            if (!Helper.isUserLoggedIn(firebase)) {
                dispatch(getGuestActivities({ firebase, startDate: dateRange[0].valueOf(), endDate: dateRange[1].valueOf() }));
            }
        }
    }, [dateRange, firebase]);

    useEffect(() => {
        if (accountPackageReducer.packageList && firebase) {
            setPackageList(accountPackageReducer.packageList.filter(pkg => {
                const centerIds = pkg.centers?.map(center => center.id) || [];
                return centerIds.length > 0 && permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_VIEW, centerIds);
            }));
        }
    }, [accountPackageReducer.packageList, firebase]);
    useEffect(() => {
        if (accountReducer.accountList && userReducer.userList) {
            const newPeopleMap = new Map();
            [...accountList, ...userList, ...teacherList].forEach((peopleObj) => {
                newPeopleMap.set(peopleObj.id, peopleObj);
            })
            setPeopleIdToObjMap(newPeopleMap);
        }
    }, [accountReducer.accountList, userReducer.userList]);

    useEffect(() => {
        if (allCentersList) {
            const newCentersMap = new Map();
            allCentersList.forEach((item) => newCentersMap.set(item.id, item));
            setCentersMap(newCentersMap);
        }
    }, [allCentersList]);

    useEffect(() => {
        if (allCentersList && firebase) {
            const filtered = allCentersList.filter(center =>
                permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_VIEW, [center.id])
            );
            setFilteredCentersList(filtered);
        }
    }, [allCentersList, firebase]);

    useEffect(() => {
        if (packageList) {
            const newPackagesMap = new Map();
            packageList.forEach((item) => newPackagesMap.set(item.id, item));
            setPackagesMap(newPackagesMap);
        }
    }, [packageList]);

    useEffect(() => {
        filterList();
    }, [activityReducer.activityList, activityReducer.packageAndCenters, search, packageFilter, centerFilter, typeFilter, visibilityFilter, peopleFilter]);

    useEffect(() => {
        if (activityReducer.activityType) {
            setTypeList([...Helper.postTypesMap.keys(), ...activityReducer.activityType.map(a => a.label)])
        }
    }, [activityReducer.activityType])

    useEffect(() => {
        setFilterNameToFilterMetaDataObjMap(getFilterNameToFilterMetaDataObjMapForStaffLogin());
    }, [packageList, packageFilter, centerFilter, filteredCentersList, peopleFilter, visibilityFilter, typeFilter, typeList, dateRange]);

    const fetchActivity = () => {
        if (!isAccount && Helper.isUserLoggedIn(firebase)) {
            activityReducer.adminActivityChannel?.close();
            activityReducer.activityTypeChannel?.close();
            dispatch(getAllAdminActivities({ firebase, startDate: dateRange[0].valueOf(), endDate: dateRange[1].valueOf() }));
            dispatch(getActivityType({ firebase }));
        }
        else if (Helper.isUserLoggedIn(firebase) && accountsFetched) {
            activityReducer.userActivityChans?.forEach(c => c?.close());
            Object.values(activityReducer.activityChannels).forEach((c: any) => c?.close());
            activityReducer.publicTimelineChan?.close();
            activityReducer.activityTypeChannel?.close();
            dispatch(getAllListingActivities({ firebase, userIds: [firebase.user?.id, ...(accountReducer.accountDetails?.users || []).map(user => user.id)], startDate: dateRange[0].valueOf(), endDate: dateRange[1].valueOf() }));
            dispatch(getActivityType({ firebase }));
        }
    }

    const getFilterUrlParam = () => {

        let search = Helper.getUrlParam("timelineSearch");
        search = Helper.checkUrlParam(search, undefined);
        if (search) setSearch(search);


        let centerFilterJSONString = Helper.getUrlParam("timelineCenterFilter");
        let centerFilterParsedJSON = centerFilterJSONString ? JSON.parse(centerFilterJSONString) : undefined;
        if (centerFilterParsedJSON) setCenterFilter(centerFilterParsedJSON);

        let packageFilterJSONString = Helper.getUrlParam("timelinePackageFilter");
        let packageFilterParsedJSON = packageFilterJSONString ? JSON.parse(packageFilterJSONString) : undefined;
        if (packageFilterParsedJSON) setPackageFilter(packageFilterParsedJSON);

        let typeFilterJSONString = Helper.getUrlParam("timelineTypeFilter");
        let typeFilterParsedJSON = typeFilterJSONString ? JSON.parse(typeFilterJSONString) : undefined;
        if (typeFilterParsedJSON) setTypeFilter(typeFilterParsedJSON);

        let visibilityFilterJSONString = Helper.getUrlParam("timelineVisibilityFilter");
        let visibilityFilterParsedJSON = visibilityFilterJSONString ? JSON.parse(visibilityFilterJSONString) : undefined;
        if (visibilityFilterParsedJSON) setVisibilityFilter(visibilityFilterParsedJSON);
    }

    const handleCenterFilterChange = useCallback((centerFilterVal) => {

        const isAllSelected: boolean = centerFilterVal?.some((val) => val === 'all centers') || false;

        if (filteredCentersList && isAllSelected) {
            centerFilterVal = filteredCentersList.map((item) => item.id);
        }

        let stringifiedData = centerFilterVal ? JSON.stringify(centerFilterVal) : '';

        setCenterFilter(centerFilterVal);
        Helper.setUrlParam('timelineCenterFilter', stringifiedData);

    }, [setCenterFilter, filteredCentersList]);

    const handleTypeFilterChange = useCallback((typeFilterVal) => {

        const isAllSelected: boolean = typeFilterVal?.some((val) => val === 'all types') || false;

        if (typeList && isAllSelected) {
            typeFilterVal = typeList;
        }

        let stringifiedData = typeFilterVal ? JSON.stringify(typeFilterVal) : '';

        setTypeFilter(typeFilterVal);
        Helper.setUrlParam('timelineTypeFilter', stringifiedData);

    }, [setTypeFilter, typeList]);

    const handleVisibilityFilterChange = useCallback((visibilityFilterVal) => {

        const isAllSelected: boolean = visibilityFilterVal?.some((val) => val === 'all') || false;

        if (visibilityList && isAllSelected) {
            visibilityFilterVal = visibilityList;
        }

        let stringifiedData = visibilityFilterVal ? JSON.stringify(visibilityFilterVal) : '';

        setVisibilityFilter(visibilityFilterVal);
        Helper.setUrlParam('timelineVisibilityFilter', stringifiedData);

    }, [setVisibilityFilter, visibilityList]);

    const handlePackageFilterChange = useCallback((packageFilterVal) => {

        const isAllSelected: boolean = packageFilterVal?.some((val) => val === 'all packages') || false;

        if (packageList && isAllSelected) {
            packageFilterVal = packageList.map((item) => item.id);
        }

        let stringifiedData = packageFilterVal ? JSON.stringify(packageFilterVal) : '';

        setPackageFilter(packageFilterVal);
        Helper.setUrlParam('timelinePackageFilter', stringifiedData);

    }, [setPackageFilter, packageList]);

    const handlePeopleFilterChange = useCallback((peopleFilterVal, type) => {
        const teacherIds = teacherList.map((teacher) => teacher.id);
        const accountIds = accountList.map((account) => account.id);
        const userIds = userList.map((user) => user.id);

        const currentFilter = new Set(peopleFilter);

        let allIdsForType: string[] = [];
        let allKeyForType = '';
        if (type === 'teacher') {
            allIdsForType = teacherIds;
            allKeyForType = 'all instructors';
        } else if (type === 'account') {
            allIdsForType = accountIds;
            allKeyForType = 'all accounts';
        } else if (type === 'user') {
            allIdsForType = userIds;
            allKeyForType = 'all participants';
        }

        allIdsForType.forEach(id => currentFilter.delete(id));

        if (peopleFilterVal.includes(allKeyForType)) {
            allIdsForType.forEach(id => currentFilter.add(id));
        } else {
            peopleFilterVal.forEach(id => currentFilter.add(id));
        }

        const updatedFilterArray = Array.from(currentFilter);
        setPeopleFilter(updatedFilterArray);
        Helper.setUrlParam('timelinePeopleFilter', JSON.stringify(updatedFilterArray));
    }, [peopleFilter, setPeopleFilter, teacherList, accountList, userList]);


    const handleSearchChange = useCallback((val) => {
        setSearch(val);
        Helper.setUrlParam('timelineSearch', val ? val : '');
    }, [setSearch]);
    const filterList = () => {
        let selectedCentersSet = new Set();
        if (centerFilter?.length) selectedCentersSet = new Set(centerFilter);

        let selectedPackagesSet = new Set();
        if (packageFilter?.length) selectedPackagesSet = new Set(packageFilter);

        let selectedTypeSet = new Set();
        if (typeFilter?.length) selectedTypeSet = new Set(typeFilter);

        let selectedVisibilitySet = new Set();
        if (visibilityFilter?.length) selectedVisibilitySet = new Set(visibilityFilter);

        let selectedPeopleSet = new Set();
        if (peopleFilter?.length) selectedPeopleSet = new Set(peopleFilter);

        let filteredData = activityReducer.activityList.filter((activity) => {
            if ((activity.visibility === "PACKAGE" || activity.visibility === "CENTER") && Helper.isUserLoggedIn(firebase) && !firebase?.teacher?.superUser) {
                const availablePackageIds = activityReducer.packageAndCenters?.packageIds || [];
                const availableCenterIds = activityReducer.packageAndCenters?.centerIds || [];

                if (activity.visibility === "PACKAGE") {
                    const isPackageMatch = activity.packageIds?.some((pkgId) => availablePackageIds.includes(pkgId));
                    if (!isPackageMatch) return false;
                }
                if (activity.visibility === "CENTER") {
                    const isCenterMatch = activity.centerIds?.some((centerId) => availableCenterIds.includes(centerId) && permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_VIEW, [centerId]))
                    if (!isCenterMatch) return false;
                }
            }

            if (activity.staffIds?.length && Helper.isTeacher(firebase))
                if (!firebase?.teacher?.superUser && firebase.user?.id !== activity.authorId && !activity.staffIds.includes(firebase?.user?.id))
                    return false;

            const teacher = Helper.getTeacherList(firebase).find((teacher) => teacher.id === activity?.authorId);

            const searchMatch = !search || search.trim() == "" || (activity.activityType && activity.activityType.toLowerCase().includes(search.toLowerCase())) || (activity.rawDescription && activity.rawDescription.toLowerCase().includes(search.toLowerCase())) || (teacher && teacher.name.toLowerCase().includes(search.toLowerCase()));

            const packageMatch =
                !packageFilter?.length ||
                (Array.isArray(activity.packageIds) &&
                    activity.packageIds.some((pkgId) => selectedPackagesSet.has(pkgId)));

            const centerMatch =
                !centerFilter?.length ||
                (Array.isArray(activity.centerIds) &&
                    activity.centerIds.some((centerId) => selectedCentersSet.has(centerId)));

            const typeMatch = !typeFilter?.length || selectedTypeSet.has(activity.activityType);

            const visibilityMatch = !visibilityFilter?.length || selectedVisibilitySet.has(activity.visibility);

            const peoplematch = !peopleFilter?.length ||
                (Array.isArray(activity.accountIds) &&
                    activity.accountIds?.some((accId) => selectedPeopleSet.has(accId))) ||
                (Array.isArray(activity.staffIds) &&
                    activity.staffIds?.some((staffId) => selectedPeopleSet.has(staffId))) ||
                (Array.isArray(activity.participantIds) &&
                    activity.participantIds?.some((Id) => selectedPeopleSet.has(Id)))


            return searchMatch && packageMatch && centerMatch && typeMatch && visibilityMatch && peoplematch;
        });
        setActivities(filteredData);
    };

    function handleScheduleClick(item) {
        setItem('selectedSchedule', item);
        router.push(`/dashboard/calendar?centerId=` + (getItem("centerId") || Helper.getUrlParam("centerId")));
    }

    function getListBody(item, ind) {
        return (
            <div
                className='timeline-schedule-container'
                style={{ cursor: 'pointer' }}
                onClick={() => handleScheduleClick(item)}
            >
                <div className='timeline-schedule-left-container'>
                    <div className='timeline-schedule-day'>
                        {timeutil.isSame(item.date, Date.now(), "day")
                            ? "Today"
                            : timeutil.isSame(item.date, timeutil.getInstance().add(1, "day"), "day")
                                ? "Tomorrow"
                                : timeutil.inFormat(item.date, Helper.dateFormat(firebase))
                        }
                    </div>

                    <div className='timeline-schedule-time'>
                        {`${timeutil.inFormat(item.startTime, "hh:mma")} - ${timeutil.inFormat(item.endTime, "hh:mma")}`}
                    </div>
                </div>
                <div className='timeline-color-divider' style={{ backgroundColor: ind == 1 ? "#FEC743" : " #8B5CF6" }}></div>
                <div className='timeline-schedule-right-container'>
                    <div className='timeline-schedule-pkg-name' style={{ color: ind == 1 ? "#B4820B" : "#8B5CF6" }}>{item.packageName}</div>
                    {Helper.isTeacher(firebase) && <div className='timeline-schedule-time'>
                        {packagesMap.get(item.packageId)?.staffIds ? (
                            <>
                                {formatMsg("with") + " " + Helper.getStaffObj(packagesMap.get(item.packageId)?.staffIds[0])?.name}
                                {packagesMap.get(item.packageId)?.staffIds.length > 1 ? "..." : ""}
                            </>
                        ) : (
                            formatMsg("noInstructor")
                        )}
                    </div>}
                </div>
            </div>
        )
    }

    const handlePageChange = useCallback((newPageNo, newPageSize) => {
        setPageNo(newPageNo);
        setPageSize(newPageSize);
        Helper.setUrlParam('pageNo', newPageNo ? newPageNo : 1);
        Helper.setUrlParam('pageSize', newPageSize ? newPageSize : 10);
        if (typeof window != "undefined") window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [setPageNo, setPageSize]);

    const [filterNameToFilterMetaDataObjMap, setFilterNameToFilterMetaDataObjMap] = useState(getFilterNameToFilterMetaDataObjMapForStaffLogin());

    function getFilterNameToFilterMetaDataObjMapForStaffLogin() {
        const arr: any = ([
            ['dateRange', {
                optionsArr: [],
                selectedVal: dateRange,
                setSelectedVal: setDateRange,
                showAllOption: false,
                filterType: 'dateRange'
            }],
            !isAccount ? ['filterLabel.centers', {
                optionsArr: filteredCentersList || [],
                selectedVal: centerFilter,
                setSelectedVal: handleCenterFilterChange,
                showAllOption: filteredCentersList.length > 1,
                filterType: 'multiSelect'
            }] : null,
            ['filterLabel.packages', {
                optionsArr: packageList || [],
                selectedVal: packageFilter,
                setSelectedVal: handlePackageFilterChange,
                showAllOption: packageList.length > 1,
                filterType: 'multiSelect'
            }],
            ['filterLabel.type', {
                optionsArr: typeList || [],
                selectedVal: typeFilter,
                setSelectedVal: handleTypeFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            }],
            ['filterLabel.visibility', {
                optionsArr: visibilityList || [],
                selectedVal: visibilityFilter,
                setSelectedVal: handleVisibilityFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            }],
            !isAccount ? ['filterLabel.instructors', {
                optionsArr: Helper.getTeacherList(firebase) || [],
                selectedVal: Array.from(peopleFilter || []).filter(id => Helper.getTeacherList(firebase).some(teacher => teacher.id === id)),
                setSelectedVal: (val) => handlePeopleFilterChange(val, "teacher"),
                showAllOption: true,
                filterType: 'multiSelect'
            }] : null,
            !isAccount ? ['filterLabel.participants', {
                optionsArr: Helper.getUserList(firebase) || [],
                selectedVal: Array.from(peopleFilter || []).filter(id => Helper.getUserList(firebase).some(user => user.id === id)),
                setSelectedVal: (val) => handlePeopleFilterChange(val, "user"),
                showAllOption: true,
                filterType: 'multiSelect'
            }] : null,
            !isAccount ? ['filterLabel.accounts', {
                optionsArr: Helper.getAccountList(firebase) || [],
                selectedVal: Array.from(peopleFilter || []).filter(id => Helper.getAccountList(firebase).some(teacher => teacher.id === id)),
                setSelectedVal: (val) => handlePeopleFilterChange(val, "account"),
                showAllOption: true,
                filterType: 'multiSelect'
            }] : null,
        ]).filter(Boolean)
        const newFilterNameToFilterMetaDataObjMap = new Map(arr);
        return newFilterNameToFilterMetaDataObjMap;
    }

    return (
        <SpinWrapper spinning={activityReducer.isLoading || accountReducer.isLoading}>
            <div className='timeline-container' style={{ paddingRight: isAccount || !Helper.isUserLoggedIn(firebase) ? "40px" : "30px" }}>
                <PageHeaderWrapper style={{ marginBottom: 0 }}>
                    <div className="global-page-header">
                        {formatMsg('timeline')}
                    </div>
                    {Helper.isTeacher(firebase) &&
                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_CREATE_POST, multicenterReducer.allCentersList?.map(center => center.id)) &&
                        <LinkWrapper
                            href={"/dashboard/timeline/createActivity"}
                        >
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: colors.v2_Cerulean,
                                    borderRadius: "6px",
                                    fontSize: "var(--font-size-16)",
                                    fontWeight: "700",
                                    color: colors.color_primarytext,
                                    whiteSpace: "nowrap",
                                    padding: "11px 16px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "125px",
                                    height: isMobile ? 32 : 40
                                }}
                            >
                                {formatMsg("createPost")}
                            </Button>
                        </LinkWrapper>
                    }
                </PageHeaderWrapper>
                <div className='timeline-filter-container'>
                    <Row gutter={[15, 12]}>
                        <Col xs={24} sm={12} md={12} lg={6} xl={5} style={styles.colStyle}>
                            <Input
                                disabled={!activityReducer.activityList?.length}
                                placeholder={formatMsg("search")}
                                style={{ width: "100%" }}
                                value={search}
                                onChange={(e) => handleSearchChange(e.target.value)}
                                suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            />
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                            <FilterDateSelector
                                dateRange={dateRange}
                                setDateRange={setDateRange}
                                defaultDateRangeType={"thisWeek"}
                                paramPrefix='activity'
                            />
                        </Col>
                        {!isAccount &&
                            <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                                <Select
                                    disabled={!activityReducer.activityList?.length}
                                    mode='multiple'
                                    onChange={handleCenterFilterChange}
                                    maxTagCount={0}
                                    maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('center', centerFilter, centersMap)}
                                    placeholder={formatMsg("centers")}
                                    style={{ width: "100%" }}
                                    value={centerFilter}
                                    allowClear
                                    popupMatchSelectWidth={false}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                                >
                                    {filteredCentersList.length > 1 && (
                                        <Select.Option
                                            key={"all"}
                                            value={"all centers"}
                                        >
                                            {formatMsg("allCenters")}
                                        </Select.Option>
                                    )}
                                    {filteredCentersList.map((center, index) => (
                                        <Select.Option
                                            key={center.id}
                                            value={center.id}
                                        >
                                            {center.name}
                                        </Select.Option>
                                    ))}

                                </Select>
                            </Col>
                        }
                        <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                            <Select
                                disabled={!activityReducer.activityList?.length}
                                mode='multiple'
                                onChange={handlePackageFilterChange}
                                maxTagCount={0}
                                maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('package', packageFilter, packagesMap)}
                                placeholder={formatMsg("packages")}
                                style={{ width: "100%" }}
                                value={packageFilter}
                                allowClear
                                popupMatchSelectWidth={false}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                            >
                                {packageList.length > 1 && (
                                    <Select.Option
                                        key={"all"}
                                        value={"all packages"}
                                    >
                                        {formatMsg("caps.allPackages")}
                                    </Select.Option>
                                )}
                                {packageList.map((item, index) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                            <Select
                                disabled={!activityReducer.activityList?.length}
                                mode='multiple'
                                onChange={handleTypeFilterChange}
                                maxTagCount={0}
                                maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('type', typeFilter)}
                                placeholder={formatMsg("type")}
                                style={{ width: "100%" }}
                                value={typeFilter}
                                allowClear
                                popupMatchSelectWidth={false}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                            >
                                <Select.Option
                                    key={"all"}
                                    value={"all types"}
                                >
                                    {formatMsg("allTypes")}
                                </Select.Option>
                                {typeList.map((type, index) => (
                                    <Select.Option
                                        key={index}
                                        value={type}
                                    >
                                        {type}
                                    </Select.Option>
                                ))}

                            </Select>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                            <Select
                                disabled={!activityReducer.activityList?.length}
                                mode='multiple'
                                onChange={handleVisibilityFilterChange}
                                maxTagCount={0}
                                maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('visibility', visibilityFilter)}
                                placeholder={formatMsg("visibility")}
                                style={{ width: "100%" }}
                                value={visibilityFilter}
                                allowClear
                                popupMatchSelectWidth={false}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                            >
                                <Select.Option
                                    key={"all"}
                                    value={"all"}
                                >
                                    {formatMsg("all")}
                                </Select.Option>
                                {visibilityList.map((vis, index) => (
                                    <Select.Option
                                        key={index}
                                        value={vis.key}
                                    >
                                        {vis.label}
                                    </Select.Option>
                                ))}

                            </Select>
                        </Col>
                        {Helper.isTeacher(firebase) && <Col xs={24} sm={12} md={12} lg={6} xl={3} style={styles.colStyle}>
                            <CustomDropdown
                                peopleIdToObjMap={peopleIdToObjMap}
                                peopleFilter={peopleFilter}
                                setPeopleFilter={setPeopleFilter}
                                disabled={!activityReducer.activityList?.length}
                                firebase={firebase}
                            />
                        </Col>}
                    </Row>
                </div>
                <div className='timeline-filter-container-mobile'>
                    <div className='mobile-calendar-filter-row'>
                        <div className='mobile-calendar-search'>
                            <Input
                                disabled={!activityReducer.activityList?.length}
                                placeholder={formatMsg("search")}
                                value={search}
                                onChange={(e) => handleSearchChange(e.target.value)}
                                suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            />
                        </div>
                        <MobileFilterButton
                            setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                            appliedFiltersCount={appliedFiltersCount}
                        />
                    </div>
                </div>
                <div className='timeline-main-container'>
                    {activities?.length ?
                        <List
                            dataSource={activities}
                            renderItem={(act) => {
                                return (
                                    <ActivityPreview
                                        activityObj={act}
                                        peopleIdToObjMap={peopleIdToObjMap}
                                        disabled={!Helper.isUserLoggedIn(firebase)}
                                    />
                                )
                            }}
                            pagination={{
                                current: pageNo,
                                pageSize: pageSize,
                                onChange: handlePageChange,
                                showSizeChanger: true,
                                hideOnSinglePage: true,
                                align: "center",
                                defaultPageSize: 20
                            }}
                            className='timeline-activity-container'
                            style={{ width: "100%" }}
                        /> :
                        <div className='timeline-no-activity-container'>
                            <div>
                                <img src="/images/emptyFeed.png" alt="no-activity" className='no-activity-img' />
                            </div>
                            <div className='no-activity-heading'>{formatMsg("noActivityHeading")}</div>
                            <div className='no-activity-desc'>{Helper.isTeacher(firebase) ? formatMsg("teacher.noActivity") : formatMsg("noActivityDesc")}</div>
                            {Helper.isTeacher(firebase) && permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_CREATE_POST, multicenterReducer.allCentersList?.map(center => center.id)) && <LinkWrapper href={"/dashboard/timeline/createActivity"}><div className='act-createPost-text'>{formatMsg("createPost")}&nbsp;<ArrowRightOutlined /></div></LinkWrapper>}
                        </div>
                    }

                    {(isAccount || !Helper.isUserLoggedIn(firebase)) && packageList?.length > 0 && <div className='timeline-packageContainer'>
                        <div className='timeline-package-header-container'>
                            <div className='timeline-package-header'>{formatMsg("ourPackages")}</div>
                            <div className='timeline-right-arrow-container' onClick={() => router.push("/dashboard")}>
                                <div className='timeline-package-header-viewall'>{formatMsg("viewAll")}</div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="8" viewBox="0 0 18 8" fill="none">
                                    <path d="M17.3536 3.64645C17.5488 3.84171 17.5488 4.15829 17.3536 4.35355L14.1716 7.53553C13.9763 7.7308 13.6597 7.7308 13.4645 7.53553C13.2692 7.34027 13.2692 7.02369 13.4645 6.82843L16.2929 4L13.4645 1.17157C13.2692 0.976311 13.2692 0.659728 13.4645 0.464466C13.6597 0.269204 13.9763 0.269204 14.1716 0.464466L17.3536 3.64645ZM1 4.5C0.723858 4.5 0.5 4.27614 0.5 4C0.5 3.72386 0.723858 3.5 1 3.5V4.5ZM17 4.5H1V3.5H17V4.5Z" fill="var(--primary-color)" />
                                </svg>
                            </div>
                        </div>
                        <div>
                            <Carousel dots={true} autoplay className='custom-slick-track'>
                                {
                                    packageList.slice(0, 6).map((pkg, index) => {
                                        if (!pkg.deleted) {
                                            return (
                                                <PackageView
                                                    packageObj={pkg}
                                                    redirectTo={`/dashboard/packageDetailView?id=${pkg.id}&centerId=` + (getItem("centerId") || Helper.getUrlParam("centerId"))}
                                                />
                                            )
                                        }
                                    })
                                }
                            </Carousel>
                        </div>
                        {calendarReducer.upcomingCalendars?.length > 0 && <div className='timeline-package-header-container'>
                            <div className='timeline-package-header'>{formatMsg("upcomingClasses")}</div>
                            <div className='timeline-right-arrow-container'
                                onClick={() => router.push("/dashboard/calendar?toggle=2")}
                            >
                                <div className='timeline-package-header-viewall'>{formatMsg("viewAll")}</div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="8" viewBox="0 0 18 8" fill="none">
                                    <path d="M17.3536 3.64645C17.5488 3.84171 17.5488 4.15829 17.3536 4.35355L14.1716 7.53553C13.9763 7.7308 13.6597 7.7308 13.4645 7.53553C13.2692 7.34027 13.2692 7.02369 13.4645 6.82843L16.2929 4L13.4645 1.17157C13.2692 0.976311 13.2692 0.659728 13.4645 0.464466C13.6597 0.269204 13.9763 0.269204 14.1716 0.464466L17.3536 3.64645ZM1 4.5C0.723858 4.5 0.5 4.27614 0.5 4C0.5 3.72386 0.723858 3.5 1 3.5V4.5ZM17 4.5H1V3.5H17V4.5Z" fill="var(--primary-color)" />
                                </svg>
                            </div>
                        </div>}
                        <div className='timeline-schedule'>
                            {calendarReducer.upcomingCalendars.slice().reverse().map((item, idx) => {
                                return (
                                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                        {getListBody(item, idx)}
                                        <div style={{ borderBottom: idx === 2 ? "none" : "0.5px solid #D0D0D0" }}></div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>}
                </div>
                <FiltersBottomSheet
                    filterNameToFilterMetaDataObjMap={filterNameToFilterMetaDataObjMap}
                    showFiltersBottomSheet={showFiltersBottomSheet}
                    setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                    setAppliedFiltersCount={setAppliedFiltersCount}
                    firebase={firebase}
                    defaultDateRangeType={"thisWeek"}
                    paramPrefix='activity'
                />
            </div>
        </SpinWrapper >
    )
}

export default page
const styles = {
    colStyle: {
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: "nowrap"
    }
}
